import { type QueryHookOptions, useQuery } from "@apollo/client";
import { AnalyticsViewsMetricsQuery } from "../graphql/queries";
import type {
  AnalyticsViewsMetricsQueryType,
  AnalyticsViewsMetricsQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useAnalyticsViewsMetricsQuery = (
  options?: QueryHookOptions<
    AnalyticsViewsMetricsQueryType,
    AnalyticsViewsMetricsQueryVariablesType
  >
) => {
  return useQuery<
    AnalyticsViewsMetricsQueryType,
    AnalyticsViewsMetricsQueryVariablesType
  >(AnalyticsViewsMetricsQuery, options);
};
